import { cn } from '@/lib/utils';
import { InputHTMLAttributes, forwardRef } from 'react';

const AppRadioButton = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ id, className, ...args }, ref) => {
    return (
      <div className="grid place-items-center">
        <input
          type="radio"
          id={id}
          ref={ref}
          {...args}
          className={cn(
            'h-4 w-4 cursor-pointer appearance-none rounded-full border-2 border-coal-300 checked:border-primary checked:bg-primary checked:shadow-[inset_0_0_0_2px_white] transition-all duration-200',
            className
          )}
        />
      </div>
    );
  }
);

AppRadioButton.displayName = 'AppRadioButton';

export default AppRadioButton;
